<template>
  <div class="vg-content">
    <van-image class="logo" width="100" height="50" :src="srcLogo"/>
    <div style="margin-top: 80px;" id="qrcode"></div>
    <!-- <van-image style="margin-top: 80px;" width="225px" height="225px" @click="test"/> -->
    <div class="text" style="margin-top: 15px;">扫码支付：¥{{ price }}</div>
    <!-- <div class="text" style="margin-top: 10px;">推荐使用手机浏览器扫描二维码</div> -->
  </div>

</template>

<script>
import {Image as VanImage} from "vant";
import srcLogo from "@/assets/login/kaidelogo.png";
import QRCode from 'qrcode2';
import {client} from "@/libraries/http";

export default {
  name: "ChargeCode",
  components: {
    VanImage,
  },
  data() {
    return {
      srcLogo: srcLogo,
      price: "",
      qrcodeTest: undefined,
      id: "",
    }
  },
  mounted() {
    console.log(this.$route.query);
    this.price = this.$route.query.price;
    this.id = this.$route.query.id;
    let url = this.getPayUrl(this.id);
    console.log(url);
    this.qrcode(url);
    this.timer = setInterval(() => this.getPayState(), 1000 * 3);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    qrcode(code) {
      document.getElementById("qrcode").innerHTML = '';
      this.qrcodeTest = new QRCode("qrcode", {
        text: code,
        width: 225,
        height: 225,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H
      });
      // console.log(this.qrcodeTest)
    },
    getPayUrl(id) {
      let path = process.env.VUE_APP_ROUTER_BASE_URL;
      return window.location.protocol + "//" + window.location.host + (path ? path : "/") + "scanVerify/chargePhone?id=" + id;
    },
    getPayState() {
      client.get('/api/h5/guard/sporadic-billing-record/state?id=' + this.id, {headers: {'Disable-Loading': 'Yes'}}
      ).then(res => {
        console.log(res);
        if (res.data.paymentStatus === "PAIED") {
          clearInterval(this.timer);
          this.$router.replace({path: '/scanVerify/chargeState', query: {state: "OK"}});
        }
      });
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
}

.logo {
  align-self: flex-start;
}

.text {
  color: #101010;
  font-size: 18px;
  font-weight: bold;
}

</style>
